<script>
import Confirmation from "@/components/PurchaseFlow/Steps/Confirmation";

export default {
  components: {
    Confirmation
  }
};
</script>

<template>
  <div>
    <h3>Confirme os dados</h3>
    <confirmation :small="true" :with-title="false" from="checkout-popup" />
    <div class="btn bg-gray" @click="$emit('comeback')">voltar</div>
  </div>
</template>

<style scoped>
div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

h3 {
  font-size: 16px;
  text-align: center;
  text-transform: uppercase;
  color: var(--green);
  margin: 0;
}

@media (min-width: 768px) {
  h3 {
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Steps/CheckoutPopup/Confirmation.vue